import React, { useState } from 'react'
import { Button,Form,Input} from 'antd';
import MemberEditHealth from './MembersEdit';
import { useDispatch,useSelector } from 'react-redux';
import axiosInHealth from '../../Redux/axios/AxiosInHealth';
import { allhealthdetails, QuickQuoteHealth,PostQuoteHealth } from "../../Redux/actions/NumHealth";
import { message } from 'antd';

export default function PincodeEdit({setTabKey,setIsModalOpenMember}) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch();
  const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
 
  const goBackToFirstTab = () => {
    setTabKey('1');
  };    
    const onFinish = (values)=>{
        console.log(values)
        const UpdatePlan = {
          ...QuotePost,
          pincode: values?.Pincode
        }
        console.log(UpdatePlan)
        setLoading(true)
        axiosInHealth
        .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, UpdatePlan)
          .then((res) => {
            if (res.status === 200) {
              const data = res?.data?.data
            console.log(data)
              // const errData = data?.filter(item => ("status" in item && item.status === "failed"));
              // dispatch(Err_quotes(errData));
              const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
              const updatedData = filteredData?.map(item => ({
                ...item,
                selected: false
              }));
              console.log(updatedData)
              dispatch(QuickQuoteHealth(updatedData));
              dispatch(PostQuoteHealth(UpdatePlan))
              setLoading(false)
              setIsModalOpenMember(false)
            }
          })
          .catch((err) => {
            console.log(err.response.data.error);
            setLoading(false)
            message.error(err.response.data.error);
          });
    }
  return (
    <>
     <Form
            form={form}
            layout="vertical"
            className='mx-auto'
            requiredMark={false}
            //initialValues={{ field4: '' }}
            onFinish={onFinish}
              >
                <Form.Item
                  name='Pincode'
                  rules={[
                    {
                      pattern: /^(\d{6})$/,
                      message: 'Invalid Pincode',
                    },
                    { required: true, message: 'Enter Pincode' },
                  ]}
                >
                <Input
                  maxLength={6}
                  placeholder="Enter Pincode"
                  >
                </Input>
            </Form.Item>
            <Form.Item>
            <div className='step-btn-health'>
                <Button 
                style={{width: "40%"}}
                //type="primary"
                onClick={goBackToFirstTab}
                >Back</Button>
              <Button 
              loading={loading}
                type="primary" 
                htmlType="submit" 
                style={{width: "40%"}}>
                Apply
              </Button>
            </div>
          </Form.Item>
          </Form>
    </>
  )
}